import $ from 'jquery';
import {} from 'sticky';

function stickyHeader(el) {
    $(el).sticky({ topSpacing: 0 });
    $(el).on('sticky-start', function () {
        $('.header').trigger('headerSticky');
    });
    $(el).on('sticky-end', function () {
        $('.header').trigger('headerNotSticky');
    });

    // Offset header background on contact page when scrolling
    if ($('body').hasClass('page-template-template-contact')) {
        $(window).scroll(function() {
            const scroll = $(window).scrollTop();
            $(el).css('--bgOffset', `-${scroll}px`);
        });
    } 
}

export default stickyHeader;
